import { render, staticRenderFns } from "./CookieConsent.vue?vue&type=template&id=0e3794c0&"
import script from "./CookieConsent.vue?vue&type=script&lang=ts&"
export * from "./CookieConsent.vue?vue&type=script&lang=ts&"
import style0 from "./CookieConsent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconCookie: require('/Users/markussh/git/theodora-tech-website/src/components/icon/Cookie.vue').default,Button: require('/Users/markussh/git/theodora-tech-website/src/components/button/Button.vue').default})
